import { render } from "./viewClientList.vue?vue&type=template&id=74874207"
import script from "./viewClientList.vue?vue&type=script&lang=js"
export * from "./viewClientList.vue?vue&type=script&lang=js"

import "./viewClientList.vue?vue&type=style&index=0&id=74874207&scope=true&lang=css"
script.render = render

export default script